import { render, staticRenderFns } from "./PasswordResetModal.vue?vue&type=template&id=0a464cb2&scoped=true"
import script from "./PasswordResetModal.vue?vue&type=script&lang=js"
export * from "./PasswordResetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a464cb2",
  null
  
)

export default component.exports